import controller from './manage-sub-delete-dialog.controller';

export default {
  controller,
  template: require('./manage-sub-delete-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/manage-sub-delete-dialog/manage-sub-delete-dialog.component.ts